import React, { Component } from 'react';
import './Sound.css';
import {Howl,Howler} from 'howler';
import Character from './Character.js'
import ZaWarudo from './audioclips/ZA_WARUDO.mp3';
import Rasengan from './audioclips/Rasengan.mp3';
import Nani from './audioclips/Nani.mp3'
import Baka from './audioclips/Baka.mp3'
import MudaMuda from './audioclips/MudaMuda.mp3'
import Wauw from './audioclips/Wauw.mp3'
import DATTEBAYO from './audioclips/DATTEBAYO.mp3'
import CruelSun from './audioclips/Cruel_sun.mp3'
import Sate from './audioclips/Sate.mp3'
import Shinra_tensei from './audioclips/Shinra_tensei.mp3'
import Omae_wa_mou_shindeiru from './audioclips/Omae_wa_mou_shindeiru.mp3'
import Mo_daijoubu from './audioclips/Mo_daijoubu.mp3'
import tuturu from './audioclips/tuturu.mp3'
import OrewaPain from './audioclips/OrewaPain.mp3'
import warrewarrewa from './audioclips/warrewarrewa.mp3'
import yowai from './audioclips/Yowai.mp3'

const audioClips =  [
     {sound: ZaWarudo, label:'Za Warudo!'},
     {sound: Rasengan, label: 'Rasengan!'},
     {sound: Nani, label: 'Nani!'},
     {sound: Baka, label: 'Baka!'},
     {sound: MudaMuda, label: 'Muda Muda Muda!'},
     {sound: Wauw, label: 'Wauw'},
     {sound: DATTEBAYO, label: 'Dattebayo'},
     {sound: CruelSun, label: 'Cruel Sun'},
     {sound: Sate, label: 'Saté Saté Saté'},
     {sound: Shinra_tensei, label: 'Shinra tensei'},
     {sound: Omae_wa_mou_shindeiru, label: 'Omae wa mou shindeiru'},
     {sound: Mo_daijoubu, label: 'MO DAIJOUBU!'},
     {sound: tuturu, label: 'tu tu ru'},
     {sound: OrewaPain, label: 'Orewa pain'},
     {sound: warrewarrewa, label: 'warre warre wa'},
     {sound: yowai, label: 'Omae wa yowai'}
]


export default class Sound extends Component {
    constructor() {
        super()
        this.state = {
            TheCharacter: 'main'
        }
    }

    SoundPlay = (src, index) => {
        const sound = new Howl({src})
        sound.play()
        this.SendImg(index)
    }

    SendImg = (index) => {
        this.setState({TheCharacter: index})
        return
        
    }

    RenderButtonAndSound = () => {
        return audioClips.map((soundObj, index) => {
            return(
                <button className="soundButton" key={index} onClick={() => this.SoundPlay(soundObj.sound, index)}>
                    {soundObj.label}
                </button>
            )
        })
    }

    render() {
        Howler.volume(1.0)
        return (
            <div><Character char={this.state.TheCharacter}/>
            <div className='SoundComponent'>
               {this.RenderButtonAndSound()}
            </div>
            </div>
        )
    }
}
